import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// This file contains the API slices for different versions of the API and backend ressources.
// Each slice is responsible for handling requests to a specific API version or backend resource.
// FUTURE: Consider refactoring to a more modular structure if the number of slices grows significantly.

const baseQueryWithAuthHandling = (options) => {
  const baseQuery = fetchBaseQuery(options);

  return async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    if (result?.error?.status === 401) {
      console.warn('🔒 Unauthorized - redirecting to login');
      if (typeof window !== 'undefined') {
        const returnTo = window.location.pathname + window.location.search;
        window.location.href = `/auth/silent-login?returnTo=${encodeURIComponent(returnTo)}`;
      }
    }

    return result;
  };
};

// ============= Handles API v1 requests ============= // 
export const apiSlice = createApi({
  baseQuery: baseQueryWithAuthHandling({
    baseUrl: '/api/v1',
    credentials: 'include',
    prepareHeaders: (headers) => {
      // No manual Authorization headers
      return headers;
    },
  }),
  endpoints: builder => ({})
});



// ============= Handles API v2 requests ============= //
export const apiSliceV2 = createApi({
  reducerPath: 'recalcV2ApiSlice',
  baseQuery: baseQueryWithAuthHandling({
    baseUrl: '/api/v2',
    credentials: 'include',
    prepareHeaders: (headers) => {
      

      return headers;
    },
  }),
  tagTypes: ['RecalcV2'],
  endpoints: builder => ({})
})



// ============= Handles Express API requests ============= //
export const expressApiSlice = createApi({
  reducerPath: 'expressApiSlice',
  baseQuery: baseQueryWithAuthHandling({
    baseUrl: '/express',
    prepareHeaders: (headers) => {
      return headers
    },
    credentials: 'include',
  }),
  // tagTypes: [''],
  endpoints: builder => ({})
})


// ============= Handles Energy Analysis API requests ============= //
export const energyAnalysisApiSlice = createApi({
  reducerPath: 'energyAnalysisApiSlice',
  baseQuery: baseQueryWithAuthHandling({
    baseUrl: '/energy-analysis',
    prepareHeaders: (headers) => {
      return headers
    }
  }),
  tagTypes: ['EnergyAnalysis'],
  endpoints: builder => ({})
})



// ============= Handles Subscription Manager API requests ============= //
export const subscriptionManagerApiSlice = createApi({
  reducerPath: 'subscriptionManagerApiSlice',
  baseQuery: baseQueryWithAuthHandling({
    // baseUrl: import.meta.env.PUBLIC_SUBSCRIPTION_MANAGER_API_URL,
    baseUrl: '/subscription-manager',
    prepareHeaders: (headers) => {
      return headers
    }
  }),
  tagTypes: ['Subscription', 'Building'],
  endpoints: builder => ({})
})
export const datahubIntegrationApiSlice = createApi({
  reducerPath: 'datahubIntegrationApiSlice',
  baseQuery: baseQueryWithAuthHandling({
    baseUrl: '/datahub-integration',
    prepareHeaders: (headers) => {
      return headers
    }
  }),
  tagTypes: ['DatahubIntegration'],
  endpoints: builder => ({})
})
export const cvrBaseApiSlice = createApi({
  reducerPath: 'cvrApi',
  baseQuery: baseQueryWithAuthHandling({
      baseUrl: 'https://datacvr.virk.dk/gateway/virksomhed/',
  }),
  endpoints: builder => ({}) // eslint-disable-line no-unused-vars
})



// ============= Handles Energy Savings API requests ============= /
export const energySavingsApiSlice = createApi({
  reducerPath: 'energySavingsApiSlice',
  baseQuery: baseQueryWithAuthHandling({
    baseUrl: '/energy-savings',
    prepareHeaders: (headers) => {
      return headers
    }
  }),
  tagTypes: ['EnergySaving'],
  endpoints: builder => ({})
})


// ============= Handles Dataforsyningen API requests ============= //
// This API is used for address lookups and other data from the Danish Dataforsyningen service
// most likely needs an update as well through the BFF
export const dataforsyningenApiSlice = createApi({
  reducerPath: 'dataforsyningenApiSlice',
  baseQuery: baseQueryWithAuthHandling({
    baseUrl: '/dataforsyningen',
    prepareHeaders: (headers) => {
      return headers
    }
  }),
  endpoints: builder => ({})
})



// ============= Handles Power BI API requests ============= //
export const powerbiApiSlice = createApi({
  reducerPath: 'powerbiApiSlice',
  baseQuery: fetchBaseQuery({
    baseUrl: '/powerbi',
    prepareHeaders: (headers) => {
      return headers
    }
  }),
  tagTypes: ['PowerBI'],
  endpoints: builder => ({})
})

// Authserver Proxy
export const authServerApiSlice = createApi({
  reducerPath: 'authServerApiSlice',
  baseQuery: baseQueryWithAuthHandling({
    baseUrl: '/auth',
    credentials: 'include',
  }),
  tagTypes: ['AuthServer'],
  endpoints: builder => ({
    getSession: builder.query({
      query: () => '/me',
    }),
  }),
});


export const { useGetSessionQuery } = authServerApiSlice; // move to dedicated auth slice
// export const { useGetDevicesQuery } = apiSliceV2;
